// Ottieni gli elementi del pop-up e del bottone
var modal = document.getElementById("size-chart-popup");
var btn = document.getElementById("open-size-chart");
var span = document.getElementById("close-size-chart");

// Quando l'utente clicca sul bottone, mostra il pop-up
btn.onclick = function() {
    modal.style.display = "block";
}

// Quando l'utente clicca sulla "X", nascondi il pop-up
span.onclick = function() {
    modal.style.display = "none";
}

// Quando l'utente clicca fuori dal pop-up, nascondilo
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
}
